<template>
  <ui-simple-modal v-model="showCreate" :ok-text="form.id? 'Сохранить' : 'Добавить'" @ok="save">
    <template v-if="form.id" #title>Редактировать образовательное учреждение #{{ form.id }}</template>
    <template v-else #title>Добавить образовательное учреждение</template>
    <p class="pb-4 text-gray-600 text-md">Укажите наименование, электронный адрес и расположение образовательной
      организации</p>
    <ui-form :errors="errors">
      <ui-form-item label="Наименование" required name="name">
        <ui-form-text v-model="form.name"/>
      </ui-form-item>
      <ui-form-item label="Email" name="email" class="mt-4">
        <ui-form-email v-model="form.email"/>
      </ui-form-item>
      <ui-form-item label="Регион" required name="region" class="mt-4">
        <ui-form-select-custom v-model="form.region" :items="regions"/>
      </ui-form-item>
      <ui-form-item label="Город" required name="city" class="mt-4">
        <ui-form-text v-model="form.city"/>
      </ui-form-item>
    </ui-form>
  </ui-simple-modal>

  <ui-ask-danger ref="ask"/>

  <div class="lg:col-span-9">
    <div class="py-6 px-4 sm:p-6 lg:pb-8">

      <div v-if="regInProgress || isReg" class="p-4 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
        <p class="font-medium text-base mb-2">Осталась последний шаг 😊</p>
        <p>Добавьте образовательные организации в которых вы
          работаете или планируете проводить мероприятия и нажмите &laquo;Завершить регистрацию&raquo;</p>
      </div>


      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-xl font-semibold text-gray-900">Образовательные организации</h1>
          <p class="mt-2 text-sm text-gray-700">
            Эта информация будет использоваться при формировании наградных документов и отчетов, вы можете добавить
            несколько организаций.
          </p>
        </div>
        <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <ui-button @click="openCreate">Добавить организацию</ui-button>
        </div>
      </div>

      <div class="mt-5 pb-24">

        <div>
          <ui-table :rows="schools">
            <ui-table-col label="#" prop="index"/>
            <ui-table-col label="Наименование" prop="name"/>
            <ui-table-col label="Email" prop="email"/>
            <ui-table-col label="Населенный пункт" prop="city"/>

            <ui-table-col label="" class="text-right pr-4">
              <template #default="{row}">
                <ui-dropdown-actions :actions="['edit', 'hr', 'remove']" @command="c=>{_action(c, row)}"/>
              </template>
            </ui-table-col>

          </ui-table>
          <ui-empty-rows v-if="schools.length === 0" @btnClick="openCreate">
            <p>Вы еще не добавили ни одного образовательного учреждения</p>
          </ui-empty-rows>

        </div>
      </div>
      <div class="mt-6 py-4 text-right" v-if="regInProgress || isReg"
           @click="$router.push({name: 'Home', query: {all_done: 'true'}})">
        <ui-button class="ml-6" color="green">Завершить регистрацию</ui-button>
      </div>
    </div>
  </div>
</template>

<script>

import UiTable from "@/components/ui/table/UiTable";
import UiTableCol from "@/components/ui/table/UiTableCol";
import UiDropdownActions from "@/components/ui/dropdown/UiDropdownActions";
import UiEmptyRows from "@/components/ui/empty-states/UiEmptyRows";
import UiSimpleModal from "@/components/ui/modal/UiSimpleModal";
import UiForm from "@/components/ui/form/UiForm";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormText from "@/components/ui/form/UiFormText";
import UiFormEmail from "@/components/ui/form/UiFormEmail";
import UiFormSelectCustom from "@/components/ui/form/select-menus/UiFormSelectCustom";
import UiButton from "@/components/ui/button/UiButton";
import UiAskDanger from "@/components/ui/ask/UiAskDanger";

export default {
  components: {
    UiAskDanger,
    UiButton,
    UiFormSelectCustom,
    UiFormEmail,
    UiFormText, UiFormItem, UiForm, UiSimpleModal, UiEmptyRows, UiDropdownActions, UiTableCol, UiTable
  },
  props: {
    user_id: {}
  },
  data() {
    return {
      errors: {},
      regions: [],
      schools: [],
      showCreate: false,
      form: {id: null, name: '', email: '', region: {}, city: ''},
      isReg: false
    }
  },
  computed: {
    regInProgress() {
      return this.$store.getters['school/requiredSchool']
    }
  },
  methods: {
    async save() {

      if (this.isReg === false)
        if (this.regInProgress)
          this.isReg = true


      const fields = {
        name: this.form.name.trim(),
        email: this.form.email.trim(),
        region: this.form.region.id,
        city: this.form.city.trim()
      }

      this.errors = {}
      try {
        if (!this.form.id) {

          await this.$store.dispatch('school/post', fields)
          this.$store.dispatch('alerts/success', {text: 'Образовательная организация успешно добавлена'})
        } else {
          await this.$store.dispatch('school/update', {id: this.form.id, fields})
          this.$store.dispatch('alerts/success', {text: 'Данные образовательная организации успешно сохранены'})
        }

        this.schools = await this.$store.dispatch('school/all')
        this.form = {name: '', email: '', region: {}, city: ''}
        this.showCreate = false
      } catch (e) {
        this.errors = e
      }

    },
    _action(cmd, row) {
      switch (cmd) {
        case 'edit':
          this.form = {...row}
          this.showCreate = true
          break
        case 'remove':
          this.$refs.ask.show({title: `Удалить ${row.name}?`}).then(async () => {
            await this.$store.dispatch('school/destroy', row.id)
            this.schools = await this.$store.dispatch('school/all')
          })
          break
      }
    },
    openCreate() {
      this.form = {id: null, name: '', email: '', region: {}, city: ''}
      this.showCreate = true
    },
  },

  async mounted() {
    this.regions = await this.$api.region.all()
    this.schools = await this.$store.dispatch('school/all')
  }
}
</script>
